import '../App.css';
import '../index.css'

const Loading = () => {
    return(
        <div className='loading'>

        </div>
    );
}
export default Loading;